import React, { useEffect } from "react";
import Intercom from "react-intercom";
import lodash from "lodash";

const RenderIntercom = () => {
  const currentUserInLocalStorage = JSON.parse(localStorage.getItem("user"));
  const impersonate = localStorage.getItem("impersonate");

  const isSchedulePersonPage =
    window.location.href.includes("schedules?personId");

  useEffect(() => {
    // Shutdown intercom when impersonating
    if (window.Intercom && impersonate) {
      window.Intercom("shutdown");
    }
  }, [impersonate]);

  // ❌ Do not load Intercom if:
  // - impersonating
  // - schedules?personId page
  // - user not available
  if (
    impersonate ||
    isSchedulePersonPage ||
    !currentUserInLocalStorage?.success ||
    lodash.isEmpty(currentUserInLocalStorage?.success)
  ) {
    return null;
  }

  const currentUser = currentUserInLocalStorage.success.user;
  const churches = currentUser?.churches || [];
  const churchForIntercom = churches.length ? churches[0] : null;

  // ✅ Keep your required logic
  const intercomAppId =
    currentUser?.env !== "production" ? "hhmdmicj" : "mrw4okeh";

  const userId = `${currentUser.env}_${currentUser.id}`;

  return (
    <Intercom
      appID={intercomAppId}
      user_id={userId}
      email={currentUser.email || ""}
      name={currentUser.name || ""}
      user_hash={currentUser.hashed_id || ""}
      created_at={currentUser.created_timestamp}
      api_base="https://api-iam.intercom.io"
      company={
        churchForIntercom
          ? {
              company_id: `${currentUser.env}_${churchForIntercom.id}`,
              name: churchForIntercom.name,
              created_at: churchForIntercom.created_timestamp,
            }
          : {}
      }
    />
  );
};

export default RenderIntercom;
